/* import __COLOCATED_TEMPLATE__ from './fin-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type FinTrialService from 'embercom/services/fin-trial-service';
import type RouterService from '@ember/routing/router-service';
const BANNER_HIDDEN_KEY = 'teammates_banner_hidden_until';

export default class FinBanner extends Component {
  @service intercomEventService: any;
  @service declare router: RouterService;
  @service declare finTrialService: FinTrialService;

  @tracked isBannerHidden = false;

  constructor(owner: unknown, args: {}) {
    super(owner, args);
    this.checkBannerHiddenState();
  }

  @action
  private checkBannerHiddenState(): void {
    let hiddenUntil = localStorage.getItem(BANNER_HIDDEN_KEY);
    if (hiddenUntil) {
      let hiddenUntilDate = new Date(hiddenUntil);
      this.isBannerHidden = hiddenUntilDate > new Date();
    }
  }

  @action
  hideBanner(): void {
    let oneMonthFromNow = new Date();
    oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
    localStorage.setItem(BANNER_HIDDEN_KEY, oneMonthFromNow.toISOString());
    this.isBannerHidden = true;
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'banner_hide_button',
      context: 'fin_trial_banner_dismiss',
    });
  }

  @action
  onBannerCtaClick(object: string): void {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object,
      context: 'fin_trial_banner_cta_clicked',
      place: 'apps.app.settings.workspace.teammates.index',
      section: 'settings_teammates_teammates_tab',
    });
    this.router.transitionTo('apps.app.automation.fin-ai-agent.content');
  }

  get showBanner(): boolean {
    return !this.isBannerHidden && this.finTrialService.canRequestTrial;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Teammates::FinBanner': typeof FinBanner;
  }
}
